module.exports = __webpack_public_path__ + "static/media/whiteGlobe.8c487b96.svg";